import React from 'react'

import Helmet from 'react-helmet'

import { BoxPricesComponent } from './BoxPricesComponent'
import { seo } from './boxPricesConfig'

const BoxPrices = () => (
  <div>
    <Helmet title={seo.title} meta={seo.meta} />
    <BoxPricesComponent />
  </div>
)

export { BoxPrices }
